import React from "react";
import { SelectOptions } from "./Options";

import { generateClassString as gcs } from "../../../../lib/helper/generateClassString";

import * as styles from "./component.module.less";

function HtmlSelect({ className, name, placeholder, options, ...props }) {
    return (
        <select
            className={gcs(styles.select, className)}
            name={name}
            placeholder={placeholder}
            {...props}
        >
            <SelectOptions name={name} options={options} />
        </select>
    );
}

export { HtmlSelect };
